import PrizeCard from '../components/PrizeCard';
import { openBondaLogin } from '../../../utils';
import AsyncButton from '../../../shared/Loading/AsyncButton';
import { exchange_enabled } from '../../../config';

const PrizesPanel = ({ setProfile, prizes, losesAccess, className = '' }) => {
  const bondaPrize = prizes?.find((prize) => prize?.title?.toLowerCase().includes('bonda'));
  const visiblePrizes = prizes?.filter((prize) => !prize?.title?.toLowerCase().includes('bonda')) || [];

  const handleNavigate = async (view) => {
    if (await losesAccess?.()) return;
    setProfile(view);
  };

  const handleBondaClick = async () => {
    if (await losesAccess?.()) return;
    openBondaLogin();
  };

  return (
    <div className={`profile-prizes-card bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden p-4 flex flex-col gap-3 ${className}`}>
      <h2 className="shrink-0 text-lg font-semibold text-gray-900 mb-3">Canjear puntos</h2>

      <div className="space-y-2 xl:flex xl:min-h-0 xl:flex-1 xl:flex-col xl:gap-3 xl:space-y-0">
        {bondaPrize && (
          <PrizeCard
            prize={bondaPrize}
            variant="bonda"
            actionLabel="Ir a la web"
            onAction={handleBondaClick}
            className="xl:min-h-0 xl:flex-1"
          />
        )}

        {visiblePrizes.map((prize, index) => (
          <PrizeCard key={prize.id} prize={prize} index={index} className="xl:min-h-0 xl:flex-1" />
        ))}
      </div>

      <div className="shrink-0 space-y-3 mt-1 xl:mt-2">
        {exchange_enabled && (
          <AsyncButton
            className="w-full bg-personalized text-white text-base py-1.5 rounded transition border
            border-transparent hover:bg-white hover:text-personalized hover:border-personalized"
            onClick={() => handleNavigate('canje')}
          >
            Ir a Canjear
          </AsyncButton>
        )}
        <AsyncButton
          className="w-full bg-personalized text-white text-base py-1.5 rounded transition
          border border-transparent hover:bg-white hover:text-personalized hover:border-personalized"
          onClick={() => handleNavigate('programa')}
        >
          Detalles del programa de puntos
        </AsyncButton>
      </div>
    </div>
  );
};

export default PrizesPanel;
